<!-- 注册sp1 -->
<template>
    <div class="screen-content">
        <div class="header">
            <div class="title">订单出库看板</div>
            <div class="search-ctn-right">
                <div class="search-name">仓库:</div>
                <el-select class="search-item" size="small" v-model="warehouseId" filterable @change="warehouseChange">
                    <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>                
                </el-select>
                <el-date-picker
                    size="small"
                    class="search-name"
                    v-model="datetime"
                    type="daterange"
                    align="right"
                    :clearable="false"
                    popper-class="icon-data"
                    style="width: 300px;border: none;"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="onDateTimeSelect"
                ></el-date-picker>
            </div>
        </div>
        <div class="neck">
            <div class="row-item">
               <div class="row-title">
                    <div class="row-label">
                        出库单数
                        <el-tooltip effect="dark" content="查询日期每天的数据" placement="top">
                            <i class="el-icon-info" style="color: orange; z-index: 99;"></i>
                        </el-tooltip>
                    </div>
                    <div class="row-value">{{ data1.value }} </div>
               </div>
               <div class="row-img" v-if="data1.list.length > 0">
                    <div id="echartCtn1"></div>
               </div>
               <div class="row-img row-noimg" v-else>
                    暂无数据
               </div>
            </div>
            <div class="row-item">
                <div class="row-title">
                    <div class="row-label">
                        商品总数
                        <el-tooltip effect="dark" content="查询日期每天的数据" placement="top">
                            <i class="el-icon-info" style="color: orange; z-index: 99;"></i>
                        </el-tooltip>
                    </div>
                    <div class="row-value">{{ data2.value }} </div>
               </div>
               <div class="row-img" v-if="data2.list.length > 0">
                    <div id="echartCtn2"></div>
               </div>
               <div class="row-img row-noimg" v-else>
                    暂无数据
               </div>
            </div>
            <div class="row-item">
                <div class="row-title">
                    <div class="row-label">
                        出库及时率
                        <el-tooltip effect="dark" content="出库及时率 = 当月完成销售出库的订单数 / 当月总出库订单数" placement="top">
                            <i class="el-icon-info" style="color: orange; z-index: 99;"></i>
                        </el-tooltip>              
                    </div>
                    <div class="row-value">{{ data3.value }}</div>
               </div>
               <div class="row-img" v-if="data3.list.length > 0">
                    <div id="echartCtn3"></div>
               </div>
               <div class="row-img row-noimg" v-else>
                    暂无数据
               </div>
            </div>
            <div class="row-item">
                <div class="row-title">
                    <div class="row-label">
                        出库达成率
                        <el-tooltip effect="dark" content="出库达成率 = 当月提交单据单日销售出库的订单数 / 当月总出库订单数" placement="top">
                            <i class="el-icon-info" style="color: orange; z-index: 99;"></i>
                        </el-tooltip>  
                    </div>
                    <div class="row-value">{{ data4.value}}</div>
               </div>
               <div class="row-img" v-if="data4.list.length > 0">
                    <div id="echartCtn4">

                    </div>
               </div>
               <div class="row-img row-noimg" v-else>
                    暂无数据
               </div>
            </div>
        </div>
        <div class="content">
            <div style="width: 32%;">
                <div class="left-div">
                    <div class="data-header">
                        <div class="header-titile">
                            <img class="header-img" src="@/assets/images/xuanzhong.png" />
                            区域出库单数
                        </div>
                    </div>
                    <div class="header-border" v-if="zoneOrderList.length > 0">
                        <div id="echartCtn5"></div>
                    </div>
                    <div class="row-noimg" v-else>
                        暂无数据
                    </div>
                </div>
                <div  class="left-div">
                    <div class="data-header">
                        <div class="header-titile">
                            <img class="header-img" src="@/assets/images/xuanzhong.png" />
                            区域出库商品总数
                        </div>
                    </div>
                    <div class="flex" v-if="zoneGoodsList.length > 0">
                        <div id="echartCtn6"></div>
                        <div class="echar-tags">
                            <div class="list-item" v-for="(item,index) in zoneGoodsList" :key="index">
                                <div class="tags-item">
                                    <div class="tags-color" :style="{'background-color':setColor(index,item.ZoneName)}"></div>
                                </div>
                                <div style="height: 100%;">{{ item.ZoneName }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row-noimg" v-else>
                        暂无数据
                    </div>
                </div>
            </div>
            <div style="width: 65%;">
                <div class="data-header" style="width: 100%;">
                    <div class="header-titile">
                        <img class="header-img" src="@/assets/images/xuanzhong.png" />
                        区域出库明细
                    </div>
                </div>
                <div class="data-content">
                    <el-table
                        ref="msgTable"
                        :data="tableData"
                        style="width: 100%; font-size: 14px"
                        :header-cell-style="{ background: '#333333' }"
                        :row-class-name="tableRowClassName"
                        :row-style="{ height: '40px' }"
                        :cell-style="{ padding: '0px' }"
                        height="580px"
                    >
                        <el-table-column type="index" min-width="3%" sortable label="序"></el-table-column>
                        <el-table-column prop="ZoneName" label="出库区域" min-width="10%" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="CreateTime" label="日期" min-width="8%" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="OrderCode" label="出库单号" min-width="25%" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="CusName" label="客户名称" min-width="15%" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="OperType" label="出库状态" min-width="8%" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <i v-if="scope.row.OperType == '待备货'" class="active1">{{ scope.row.OperType }}</i>
                                <i v-else-if="scope.row.OperType == '待打包'" class="active2">{{ scope.row.OperType }}</i>
                                <i v-else-if="scope.row.OperType == '已备货'" class="active3">{{ scope.row.OperType }}</i>
                                <i v-else-if="scope.row.OperType == '已开始打包'" class="active4">{{ scope.row.OperType }}</i>
                                <i v-else-if="scope.row.OperType == '等待发货'" class="active5">{{ scope.row.OperType }}</i>
                                <i v-else>{{ scope.row.OperType }}</i>
                            </template></el-table-column
                        >
                        <el-table-column prop="ShipTypeName" label="发货方式" min-width="8%" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="GoodsCount" label="商品数量" min-width="8%" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="SOrderCode" label="关联销售单号" min-width="15%"  show-overflow-tooltip> </el-table-column>

                    </el-table>
                </div>
            </div>
        </div>
        <audio ref="audio" controls hidden></audio>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import { setInterval, clearTimeout } from 'timers';
export default {
    mixins: [mixin],
    name: '',
    components: {},
    data() {
        return {
            timer: null,
            timeOut: null,
            timer2: null,
            timeOut2: null,
            tableData: [],
            userInfo : this.$util.getLocalStorage('userMsg'),
            newOrderAudio: '/download/neworder.mp3',
            date: new Date(),
            page: 0,
            thispage: 0,
            warehouseList:[],
            warehouseId: "",
            datetime:[],
            startDate: "",
            endDate: "",
            data1: {
                value:'0',
                list:{},
            },
            data2: {
                value:'0',
                list:{},
            },
            data3: {
                value:'0.00%',
                list:{},
            },
            data4: {
                value:'0.00%',
                list:{},
            },
            series:{},
            zoneOrderList:{},//用于图表生成的数据
            zoneGoodsList:{},//用于图表生成的数据
            colorArr : [
                '#61A5E8',
                '#E16757',
                '#E3935D',
                '#EECB5F',
                '#7ECF51',
                '#9570E5',
                '#ca8622',
                '#bda29a',
                '#6e7074',
                '#546570',
                '#c4ccd3',
                '#dd6b66',
                '#759aa0',
                '#e69d87',
                '#8dc1a9',
                '#ea7e53',
                '#eedd78',
                '#73a373',
                '#73b9bc',
                '#7289ab',
                '#91ca8c',
                '#f49f42',
                '#37A2DA',
                '#32C5E9',
                '#67E0E3',
                '#9FE6B8',
                '#FFDB5C',
                '#ff9f7f',
                '#fb7293',
                '#E062AE',
                '#E690D1',
                '#e7bcf3',
                '#9d96f5',
                '#8378EA',
                '#96BFFF'
            ],
            selectDate:'',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                onPick: ({ maxDate, minDate }) => {
                    this.selectDate = minDate.getTime();
                    if (maxDate) {
                        this.selectDate = '';
                    }
                },
                disabledDate: time => {
                    if (this.selectDate !== '') {
                        const one = 30 * 24 * 3600 * 1000;
                        const minTime = this.selectDate - one;
                        const maxTime = this.selectDate + one;
                        return time.getTime() < minTime || time.getTime() > maxTime;
                    }
                }
            }
        };
    },
    watch:{
        data1(value){
            setTimeout(() => {
                this.initEchart1();
            }, 500);
        },
        data2(value){
            setTimeout(() => {
                this.initEchart2();
            }, 500);
        },
        data3(value){
            setTimeout(() => {
                this.initEchart3();
            }, 500);
        },
        data4(value){
            setTimeout(() => {
                this.initEchart4();
            }, 500);
        }
    },
    mounted() {
        let that = this;
        let stoId = this.$util.getLocalStorage('allOrderScreen' + this.userInfo.EmployeeId);
        if(stoId){
            this.warehouseId = stoId;
        }
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        that.datetime.push(date1);

        //前七天设定的日期时间
        let year2, month2, day2;
        const d2 = new Date(d.getTime());
        d2.setDate(d.getDate() - 7);
        [year2, month2, day2] = [d2.getFullYear(), d2.getMonth(),d2.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        that.datetime.unshift(date2);

        that.startDate = date2;
        that.endDate = date1;
        that.getWarehouseList();

        const table = this.$refs.msgTable;
        const divData = table.bodyWrapper;
        that.timer = setInterval(() => {
            that.thispage++;
            divData.scrollTop += 500;
            if (that.thispage > that.page) {
                that.thispage = 0;
                divData.scrollTop = 0;
            }
        }, 5000);
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
        if (this.timeOut) window.clearTimeout(this.timeOut);
        if (this.timer2) clearInterval(this.timer2);
        if (this.timeOut2) window.clearTimeout(this.timeOut2);

    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            return 'bgC';
        },
        getWarehouseList() {
            this.$util.getWarehouse(0).then(data => {
                this.warehouseList = data;
                if(data.length > 0 && this.warehouseId == '')
                    this.warehouseId = data[0].WarehouseId;
                this.starTimer();
                this.starTimer2();
            });
        },
        warehouseChange(value){
            this.$util.setLocalStorage('allOrderScreen' + this.userInfo.EmployeeId,value);
            this.warehouseId = value;
            this.starTimer();
            this.starTimer2();
        },
        //选中时间
        onDateTimeSelect(val) {
            if (val != null) {
                this.startDate = val[0];
                this.endDate = val[1];
            } else {
                this.startDate = '';
                this.endDate = '';
            }
            this.starTimer();
            this.starTimer2();
        },
        getHeaderData() {
            let that = this;
            if (that.timeOut2) {
                window.clearTimeout(that.timeOut2);
            }
            return new Promise(resolve => {
                that.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpZoneOrderOutData',
                    hideLoading: true,
                    data:{StoId:that.warehouseId,StartDate:that.startDate,EndDate:that.endDate}
                })
                .then(res => {
                    if(res.errcode == 0){
                        let data = res.data;
                        this.data3 = data.deliveryRate;
                        this.data4 = data.deliveryAchRate;
                    }
                }).finally(() => {
                    resolve();
                });
            });
        },
        getTableData() {
            let that = this;
            if (that.timeOut) {
                window.clearTimeout(that.timeOut);
            }
            return new Promise(resolve => {
                that.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetEntpZoneOrderOpLogData_V2',
                        hideLoading: true,
                        data:{StoId:that.warehouseId,StartDate:that.startDate,EndDate:that.endDate}
                    })
                    .then(res => {
                        let data = res.data.DataList;
                        if (data) {
                            that.page = Math.ceil(res.count / 10.0);
                            let tdata = that.tableData;
                            that.tableData = data;
                            let isNew = false;
                            data.forEach(item => {
                                let sameData = tdata.find(e => e.OrderCode == item.OrderCode);
                                if (!sameData) {
                                    isNew = true;
                                    return;
                                }
                            });
                            that.tableData = data;
                            that.data1 = res.data.zoneOrderCount;
                            that.data2 = res.data.zoneGoodsCount;
                            that.zoneOrderList = res.data.zoneOrderList;
                            that.zoneGoodsList = res.data.zoneGoodsList;
                            if (isNew) that.aplayAudio(that.newOrderAudio);

                        }
                    })
                    .finally(() => {
                        that.initEchart5();
                        that.initEchart6();
                        resolve();
                    });
            });
        },
        starTimer() {
            this.getTableData().then(data => {
                this.requestAF(this.starTimer);
            });
        },
        requestAF(callback) {
            this.timeOut = window.setTimeout(callback, 20000);
        },
        starTimer2() {
            this.getHeaderData().then(data => {
                this.requestAF2(this.starTimer2);
            });
        },
        requestAF2(callback) {
            this.timeOut2 = window.setTimeout(callback, 1200000);
        },
        aplayAudio(audioUrl) {
            this.$refs.audio.src = audioUrl;
            this.$nextTick(res => {
                this.$refs.audio.load();
            });
        },
        setColor(index,value){
            if(value == "无关联区域")
                return '#d925a2'
            var i = index;
            if(i >= this.colorArr.length)
                i = i - this.colorArr.length + 1;
            return this.colorArr[i];
        },
        initEchart1() {
            if(this.data1.list.length == 0) return
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('echartCtn1'));
            ///这里空的时候会返回整个集合，只需要一个一维数组数据
            let xArr = this.data1.list.map(x=> x.Day);
            if(xArr.length == 0) xArr = [];
            let yArr = this.data1.list.map(x=> x.OrderCount);
            if(yArr.length == 0) yArr = [];

            // 绘制图表
            myChart.setOption({
                grid: { 
                    left: '15%',   // 左侧留空10%宽度
                    right: '5%',   // 右侧留空5%宽度
                    top: '10%',    // 顶部留空15%高度
                    bottom: '20%'  // 底部留空10%高度
                },
                xAxis: {
                    type: 'category',
                    data: xArr,
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF',      // 轴线颜色
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        color: '#FFFFFF'        // 轴标签颜色
                    },
                    splitLine: {
                        show: true, // 是否显示网格线
                        lineStyle: {
                        color: '#FFFFFF', // 网格线颜色
                        width: 1, // 网格线的宽度
                        type: 'dashed' // 网格线类型
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                series: [
                    {
                        data: yArr,
                        type: 'line',
                        smooth: true
                    }
                ]
            });
        },
        initEchart2() {
            if(this.data2.list.length == 0) return
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('echartCtn2'));
            ///这里空的时候会返回整个集合，只需要一个一维数组数据
            let xArr = this.data2.list.map(x=> x.Day);
            if(xArr.length == 0) xArr = [];
            let yArr = this.data2.list.map(x=> x.GoodsCount);
            if(yArr.length == 0) yArr = [];
            // 绘制图表
            myChart.setOption({
                grid: { 
                    left: '15%',   // 左侧留空10%宽度
                    right: '5%',   // 右侧留空5%宽度
                    top: '10%',    // 顶部留空15%高度
                    bottom: '20%'  // 底部留空10%高度
                },
                xAxis: {
                    type: 'category',
                    data: xArr,
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF',      // 轴线颜色
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        color: '#FFFFFF'        // 轴标签颜色
                    },
                    splitLine: {
                        show: true, // 是否显示网格线
                        lineStyle: {
                        color: '#FFFFFF', // 网格线颜色
                        width: 1, // 网格线的宽度
                        type: 'dashed' // 网格线类型
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                series: [
                    {
                        data: yArr,
                        type: 'line',
                        smooth: true
                    }
                ]
            });
        },
        initEchart3() {
            if(this.data3.list.length == 0) return
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('echartCtn3'));

             ///这里空的时候会返回整个集合，只需要一个一维数组数据
             let xArr = this.data3.list.map(x=> x.Day);
            if(xArr.length == 0) xArr = [];
            let yArr = this.data3.list.map(x=> x.Rate1);
            if(yArr.length == 0) yArr = [];

            // 绘制图表
            myChart.setOption({
                grid: { 
                    left: '15%',   // 左侧留空10%宽度
                    right: '5%',   // 右侧留空5%宽度
                    top: '10%',    // 顶部留空15%高度
                    bottom: '20%'  // 底部留空10%高度
                },
                xAxis: {
                    type: 'category',
                    data: xArr,
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF',      // 轴线颜色
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        color: '#FFFFFF'        // 轴标签颜色
                    },
                    splitLine: {
                        show: true, // 是否显示网格线
                        lineStyle: {
                        color: '#FFFFFF', // 网格线颜色
                        width: 1, // 网格线的宽度
                        type: 'dashed' // 网格线类型
                        }
                    },
                    axisLabel: {
                        formatter: '{value} %',
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                series: [
                    {
                        data: yArr,
                        type: 'line',
                        smooth: true
                    }
                ]
            });
        },
        initEchart4() {
            if(this.data4.list.length == 0) return
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('echartCtn4'));
            
             ///这里空的时候会返回整个集合，只需要一个一维数组数据
            let xArr = this.data4.list.map(x=> x.Day);
            if(xArr.length == 0) xArr = [];
            let yArr = this.data4.list.map(x=> x.Rate2);
            if(yArr.length == 0) yArr = [];

            // 绘制图表
            myChart.setOption({
                grid: { 
                    left: '15%',   // 左侧留空10%宽度
                    right: '5%',   // 右侧留空5%宽度
                    top: '10%',    // 顶部留空15%高度
                    bottom: '20%'  // 底部留空10%高度
                },
                xAxis: {
                    type: 'category',
                    data: xArr,
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF',      // 轴线颜色
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        color: '#FFFFFF'        // 轴标签颜色
                    },
                    splitLine: {
                        show: true, // 是否显示网格线
                        lineStyle: {
                            color: '#FFFFFF', // 网格线颜色
                            width: 1, // 网格线的宽度
                            type: 'dashed' // 网格线类型
                        }
                    },
                    axisLabel: {
                        formatter: '{value} %',
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                series: [
                    {
                        data: yArr,
                        type: 'line',
                        smooth: true
                    }
                ]
            });
        },
        initEchart5() {
            let len = this.zoneOrderList.length;
            if(len == 0) return
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('echartCtn5'));

            let barWidth = 26;
            if(len > 7){
                barWidth = 250 / (len * 2) > 5 ? 250 / (len * 2) : 5; 
            }

            // 绘制图表
            myChart.setOption({
                dataset: {
                    source: this.zoneOrderList
                },
                grid: { 
                    left: '15%',   // 左侧留空10%宽度
                    right: '5%',   // 右侧留空5%宽度
                    top: '10%',    // 顶部留空15%高度
                    bottom: '10%'  // 底部留空10%高度
                },
                xAxis: { 
                    type:'value',
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF',      // 轴线颜色
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                yAxis: { 
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF',      // 轴线颜色
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',        // 轴标签颜色
                        fontSize:10
                    }
                },
                series: [
                    {
                        type: 'bar',
                        barWidth:barWidth,
                        encode: {
                            x: 'OrderCount',
                            y: 'ZoneName'
                        },
                        nameTextStyle: {
                            color: '#FFFFFF',
                        },
                        itemStyle:{ //设置柱子颜色
                            color:'#e28b06'
                        },
                        // label: {
                        //     show: true, // 是否显示标签
                        //     position: 'top', // 标签位置
                        //     textStyle: { // 字体样式
                        //         fontSize: 16, // 标签字体大小
                        //     }
                        // },
                    }
                ]
            });
        },
        initEchart6() {
            if(this.zoneGoodsList.length == 0) return
            let zoneGoodsList = this.zoneGoodsList; // 确保数据存在
            let colorArr = this.colorArr;
            let myChart = this.$echarts.init(document.getElementById('echartCtn6'));

            myChart.setOption({
                dataset: { source: zoneGoodsList },
                grid: { 
                    left: '10%',   // 左侧留空10%宽度
                    right: '5%',   // 右侧留空5%宽度
                    top: '10%',    // 顶部留空10%高度
                    bottom: '10%'  // 底部留空10%高度
                },
                xAxis: { 
                    type:'category',
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF',      // 轴线颜色
                        }
                    },
                    axisLabel: {
                        show: false     // 轴标签颜色
                    }
                },
                yAxis: { 
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF',      // 轴线颜色
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF'        // 轴标签颜色
                    }
                },
                series: [{
                    type: 'bar',
                    barWidth:26,
                    encode: {
                        x: 'ZoneName',
                        y: 'GoodsCount'
                    },
                    itemStyle: {
                        color: function(params) {
                            if(params.data.ZoneName == "无关联区域")
                                return '#d925a2'

                            var i = params.dataIndex;
                            if(i >= colorArr.length)
                                i = i - colorArr.length + 1;
                            return colorArr[params.dataIndex];
                        }
                    }
                }]
            });
        }
    }
};
</script>
<style lang="less" scoped>
.screen-content {
    width: 100%;
    height: 100vh;
    background-color: #191e24;
}
/deep/ .gutter {
  display: none;
}
.screen-content .header {
    height: 70px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 10px;
    margin-bottom: 20px;
    color: #ffffff;
    font-weight: 700;

    .search-item{
        width: 160px;
    }
    /deep/ .el-input__inner{
        color: #ffffff;
        font-size:20px;
        background-color: #252a2f !important;
    }
    /deep/ .el-range-input{
        width: 120px;
        color: #ffffff;
        font-size:18px;
        border: #ffffff 1px solid;
        border-radius: 3px;
        background-color: #252a2f !important;
    }
    /deep/ .el-date-editor .el-range__icon{
        font-size: 30px;
        color: #ffffff;
        margin-right: 10px;
    }
    /deep/  .el-range-separator{
        color: #ffffff;
        padding-right: 25px;
        padding-left: 10px;
    }
    .title {
        font-size: 36px;
        width: 50%;
        text-align: right;
    }
    .search-ctn-right{
        display: flex;
        justify-content: end;
        width: 50%;
        margin-right:100px;
    }
    .datetime {
        font-size: 72px;
        font-weight: 700;
        color: rgba(255, 255, 255, 0.952);
    }
    .otherdatas {
        display: flex;
        flex-direction: column;
        font-size: 32px;
        font-weight: 650;
        color: #ccff66;
        margin-right: 30px;

        .otheritems1 {
            display: flex;
            flex-direction: row;
            margin-bottom: 20px;

            .item1 {
                width: 190px;
                margin-right: 20px;
            }
        }
        .otheritems2 {
            display: flex;
            flex-direction: row;

            .item1 {
                width: 190px;
                margin-right: 20px;
            }
        }
    }
}
.screen-content .neck{
    height: 130px;
    display: flex;
    justify-content: start;
    align-items: center;
    margin-left: 20px;
    .row-item{
        width: 23%;
        display: flex;
        margin: 0  50px 20px 0;
        height: 130px;
        color: #ffffff;
        background-color: rgb(31,36,42);
        .row-title{
            width: 30%;
            height: 100%;
            .row-label{
                height: 50%;
                font-size: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .row-value{
                height: 50%;
                font-size: 26px;
                text-align: center;
                font-weight: 700;
            }
        }
        .row-img{
            width: 70%;
            height: 100%;
        }
    }
}
.row-noimg{
    display: flex;
    justify-content: center;
    align-items: center;
}
.content{
    display: flex;
    margin: 20px 0 0 20px;
}
.left-div{
    width: 95%;
    height:320px;
    .row-noimg{
        width: 100%;
        height: 250px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
.data-header{
    width: 100%;
    height: 50px;
    border-bottom: #5d5e60 3px solid;
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 10px;
}
.header-titile{
    display: flex;
    align-items: center;
    justify-items: center;
    width: 200px;
    height: 50px;
    background-color: #252a2f;
    padding-left: 5px;
    border-bottom: #5d5e60 3px solid;
}
.header-img{
    width: 18px; 
    height: 18px;
    margin-right: 10px;
}
.data-content{
    width: 100%;
    height: 580px;
    overflow: hidden;
}
#echartCtn1{
    width: 100%;
    height: 130px;
}
#echartCtn2{
    width: 100%;
    height: 130px;
}
#echartCtn3{
    width: 100%;
    height: 130px;
}
#echartCtn4{
    width: 100%;
    height: 130px;
}
#echartCtn5{
    width: 100%;
    height: 250px;
}
#echartCtn6{
    width: 80%;
    height: 250px;
}
.echar-tags{
    width:20%;
    height: 280px;
    color: #ffffff;
    overflow: auto;
}
::-webkit-scrollbar {
    width: 0px;
}

.list-item{
    width: 110px;
    height: auto;
    display: flex;
    margin: 5px 0;
    font-weight: 700;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: normal;
}
.tags-item{
    width: 18px;
    height: 100%;
    margin-right: 5px;
}
.tags-color{
    display:inline-block;
    width: 18px;
    height: 18px;
    margin-right: 10px;
}
/deep/ .el-table__empty-block{
    background-color: #191e24;

}
@media screen and (max-width: 1760px) {
    .screen-content .header {
        height: 100px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 20px;
        margin-bottom: 40px;

        .title {
            font-size: 70px;
            font-weight: 700;
            color: rgb(3, 194, 245);
            margin-left: 30px;
        }
        .datetime {
            font-size: 64px;
            font-weight: 700;
            color: rgba(255, 255, 255, 0.952);
        }
        .otherdatas {
            display: flex;
            flex-direction: column;
            font-size: 28px;
            font-weight: 650;
            color: #ccff66;
            margin-right: 30px;

            .otheritems1 {
                display: flex;
                flex-direction: row;
                margin-bottom: 10px;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
            .otheritems2 {
                display: flex;
                flex-direction: row;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
        }
    }
}

@media screen and (max-width: 1600px) {
    .screen-content .header {
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 20px;
        margin-bottom: 40px;

        .title {
            font-size: 60px;
            font-weight: 700;
            color: rgb(3, 194, 245);
            margin-left: 20px;
        }
        .datetime {
            font-size: 50px;
            font-weight: 700;
            color: rgba(255, 255, 255, 0.952);
        }
        .otherdatas {
            display: flex;
            flex-direction: column;
            font-size: 26px;
            font-weight: 650;
            color: #ccff66;
            margin-right: 30px;

            .otheritems1 {
                display: flex;
                flex-direction: row;
                margin-bottom: 10px;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
            .otheritems2 {
                display: flex;
                flex-direction: row;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
        }
    }
}

@media screen and (max-width: 1380px) {
    .screen-content {
        width: 1380px;
        height: 100%;
        background: #252a2f;
    }
    .screen-content .header {
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 20px;
        margin-bottom: 40px;

        .title {
            font-size: 60px;
            font-weight: 700;
            color: rgb(3, 194, 245);
            margin-left: 20px;
        }
        .datetime {
            font-size: 40px;
            font-weight: 700;
            color: rgba(255, 255, 255, 0.952);
        }
        .otherdatas {
            display: flex;
            flex-direction: column;
            font-size: 26px;
            font-weight: 650;
            color: #ccff66;
            margin-right: 30px;

            .otheritems1 {
                display: flex;
                flex-direction: row;
                margin-bottom: 10px;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
            .otheritems2 {
                display: flex;
                flex-direction: row;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
        }
    }
}

.active1 {
    color: rgb(244, 67, 54);
}
.active2 {
    color: #ff0097;
}
.active3 {
    color: rgb(139, 195, 74);
}
.active4 {
    color: #0dbdae;
}
.active5 {
    color: rgb(255, 193, 7);
}
</style>
<style lang="less">
.screen-content .el-table {
    color: #fff;
    background: #191e24;

    .el-table__body-wrapper::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
    }
    .cell {
        line-height: 40px;
        color: #fff !important;
        text-overflow:clip;
    }
    td.el-table__cell div {
        color: #fff !important;
    }
    th{
        padding:8px 0;
    }
    .bgC {
        background: #252a2f;
    }
}
</style>
